/*global _, addiesaas */
const providers = _.get(addiesaas, 'config.social.services', {})
export default providers
